module.exports = __webpack_public_path__ + "img/thumb-vegan-bloemkoolcurry-met-kikkererwten.634cc22c.jpeg";